import React from 'react';

export type MetadataIconType = 'nights' | 'room' | 'person';

interface MetadataWithIconProps {
  text: string;
  icon: MetadataIconType;
  /** Optional custom icon renderer - if not provided, uses default inline SVGs */
  renderIcon?: (icon: MetadataIconType) => React.ReactNode;
}

/** Default icon renderer using inline SVGs */
const defaultRenderIcon = (icon: MetadataIconType): React.ReactNode => {
  switch (icon) {
    case 'nights':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      );
    case 'room':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      );
    case 'person':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      );
  }
};

export const MetadataWithIcon: React.FC<MetadataWithIconProps> = ({
  text,
  icon,
  renderIcon = defaultRenderIcon,
}) => {
  return (
    <div className="flex flex-row gap-1.5 items-center">
      {renderIcon(icon)}
      <p className="font-bold text-sm">{text}</p>
    </div>
  );
};
